// @ vendor
const React = require('react');
const { Route } = require('react-router-dom');
const findIndex = require('lodash/array/findIndex');

// @ constants
const { CONTACT_CENTER_EXCLUDED_ROUTES, CONTACT_CENTER_ONLY_ROUTES } = require('constants/contactCenter/regex');
const { ENABLE_RETAIL_LOAN_HIRE_IN_CC } = require('constants/index');

// @ actions
const { redirectToNerudaUserPages } = require('actions/nerudaUser');

// @ utilities
const { PAGE_ERROR } = require('utilities/tagging');

// @ store
const { store } = require('store/configureStore');

// @ views
const { AgentLoginView } = require('routes/disasterRecovery/agentLogin/agentLoginView');
const { CustomerFinderViewContainer } = require('routes/disasterRecovery/customerFinderViewContainer/customerFinderViewContainer');
const { HireWelcomeAccountView } = require('routes/hireWelcomeAccountView/hireWelcomeAccountView');
const { HireWelcomePayrollAccountView } = require('routes/hireWelcomeAccountView/hireWelcomePayrollAccountView');
const { KeysSendDisasterViewContainer } = require('routes/KeysSendView/KeysSendDisasterViewContainer');
const { SessionView } = require('routes/sessionView/sessionView');
const { LoginAsClientViewContainer } = require('routes/loginAsClientView/loginAsClientViewContainer');
const { SendN1PasswordViewContainer } = require('routes/SendN1PasswordView/sendN1PasswordViewContainer');
const { SendN2PasswordViewContainer } = require('routes/SendN2PasswordView/sendN2PasswordViewContainer');
const { ContactCenterLandingPage } = require('routes/contactCenterLandingPage/contactCenterLandingPage');
const { UnknownSecurityLevelView } = require('routes/unknownSecurityLevelView/unknownSecurityLevelView');
const { RedirectToContactCenterView } = require('routes/redirectToContactCenterView/redirectToContactCenterView');
const { NavigateToPathView } = require('routes/navigateToPathView/navigateToPathView');
const { KeysSendViewContainer } = require('routes/KeysSendView/KeysSendViewContainer');
const { AccountBenefitsViewContainer } = require('routes/accountBenefitsView/accountBenefitsViewContainer');
const { AccountDebitsChangeAccountContainer } = require('routes/accountDebitsChangeAccountContainer/accountDebitsChangeAccountContainer');
const { ImpositionEarlyCancelContainer } = require('routes/contactCenter/impositionEarlyCancelContainer/impositionEarlyCancelContainer');
const { ImpositionInterestRenewalContainer } = require('routes/contactCenter/impositionInterestRenewalContainer/impositionInterestRenewalContainer');
const { BrokerPensionPlanCancelPendingOrderContainer } = require('routes/contactCenter/brokerPensionPlanCancelPendingOrder/brokerPensionPlanCancelPendingOrderContainer');
const { ImpositionEarlyCancelSimulationContainer } = require('routes/contactCenter/impositionEarlyCancelSimulationContainer/impositionEarlyCancelSimulationContainer');
const { CardTransferMoneyToCheckingAccountView } = require('routes/cardTransferMoneyToCheckingAccountView/cardTransferMoneyToCheckingAccountView');
const { CancelPostPaymentView } = require('routes/cancelPostPaymentView/cancelPostPaymentView');
const { SendPinByMailViewContainer } = require('routes/sendPinByMailView/sendPinByMailViewContainer');
const { AuthorizeBizumViewContainer } = require('routes/authorizeBizumView/authorizeBizumViewContainer');
const { CancelBizumViewContainer } = require('routes/cancelBizumView/cancelBizumViewContainer');
const { GapAccessViewContainer } = require('routes/gapAccessView/gapAccessViewContainer');
const { CardRequestAdditionalViewContainer } = require('routes/cardRequestAdditionalView/cardRequestAdditionalViewContainer');
const { AddImpositionDepositView } = require('routes/addImpositionDepositView/addImpositionDepositView');
const { DepositChangeAccountView } = require('routes/depositChangeAccountView/depositChangeAccountView');
const { CardPinResetViewContainer } = require('routes/cardPinResetViewContainer/cardPinResetViewContainer');
const { CreditModifyAssociatedAccountView } = require('routes/creditModifyAssociatedAccountView/creditModifyAssociatedAccountView');
const { CancelCreditCardRenewalView } = require('routes/cancelCreditCardRenewalView/cancelCreditCardRenewalView');
const { CancelCardPayLaterWizardView } = require('routes/cancelCardPayLaterWizardView/cancelCardPayLaterWizardView');
const { CancelCardPayLaterView } = require('routes/cancelCardPayLaterView/cancelCardPayLaterView');
const { CreditInvestmentWarrantiesView } = require('routes/contactCenter/creditInvestmentWarrantiesView/creditInvestmentWarrantiesView');
const { CardsControlHistoryViewContainer } = require('routes/contactCenter/cardsControlHistoryViewContainer/cardsControlHistoryViewContainer');
import { SavingsAccountsOffersView }  from 'routes/savingsAccountsOffersView/savingsAccountsOffersView';
const { AccountWarningsView } = require('routes/contactCenter/accountWarningsView/accountWarningsView');
const { DepositDetailsView } = require('routes/contactCenter/depositDetailsView/depositDetailsView');
const { UpdateClientContactTimeView } = require('routes/contactCenter/updateClientContactTimeView/updateClientContactTimeView');
const { ModifyCommerceAndATMLimitsContainer } = require('routes/contactCenter/modifyCommerceAndATMLimits/modifyCommerceAndATMLimitsContainer');
const { ModifyMainPhoneContainer } = require('routes/contactCenter/modifyMainPhone/modifyMainPhoneContainer');
const { AccountsViewWrapper } = require('routes/accountsView/accountsViewWrapper');
const { CardsViewWrapper } = require('routes/cardsView/cardsViewWrapper');
const { SendExtractsViaMailContainer } = require('routes/contactCenter/sendExtractsViaMail/sendExtractsViaMailContainer');
const { DepositRenovationCancelContainer } = require('routes/contactCenter/depositRenovationCancelContainer/depositRenovationCancelContainer');

const getContactCenterRoutes = (mOE, routeGroup) => {
    const CONTACT_CENTER_ROUTES = {
        '/': [
            <Route render={(routeProps) => {
                mOE('agentLogin');
                return <AgentLoginView {...routeProps} />;
            }} path="/disasterRecovery/agentLogin" />,
            <Route render={(routeProps) => {
                mOE('customerFinder');
                return <CustomerFinderViewContainer {...routeProps} />;
            }} path="/disasterRecovery/customerFinder" />,
            <Route render={(routeProps) => {
                mOE('claves/recuperar');
                return <KeysSendDisasterViewContainer {...routeProps} />;
            }} path="/disasterRecovery/keys-recovery" />,
            <Route render={(routeProps) => {
                mOE('session', PAGE_ERROR);
                return <SessionView {...routeProps} />;
            }} path="/session" />,
            <Route render={(routeProps) => {
                mOE('claves/enviar');
                return <KeysSendViewContainer {...routeProps} />;
            }} path="/keys/send" />,
            <Route render={(routeProps) => {
                mOE('claves/log-como-cliente');
                return <LoginAsClientViewContainer {...routeProps} />;
            }} path="/keys/login-as-client" />,
            <Route render={(routeProps) => {
                mOE('claves/solicitar-envio');
                return <SendN1PasswordViewContainer {...routeProps} />;
            }} path="/keys/send-n1-post" />,
            <Route render={(routeProps) => {
                mOE('claves/solicitar-envio-n2');
                return <SendN2PasswordViewContainer {...routeProps} />;
            }} path="/keys/send-n2-post" />,
            <Route render={(routeProps) => {
                mOE('contact-center');
                return <ContactCenterLandingPage {...routeProps} />;
            }} path="/contactCenterLandingPage" />,
            <Route render={(routeProps) => {
                mOE('unknown-security-level');
                return <UnknownSecurityLevelView {...routeProps} />;
            }} path="/unknown-security-level" />,
            <Route render={(routeProps) => {
                mOE('redirect-to-contact-center');
                return <RedirectToContactCenterView {...routeProps} />;
            }} path="/redirect-to-contact-center" />,
            <Route render={(routeProps) => {
                mOE('navigate-to-path');
                return <NavigateToPathView {...routeProps} />;
            }} path="/navigate-to-path" />,
            <Route render={(routeProps) => {
                mOE('gap-access');
                return <GapAccessViewContainer {...routeProps} />;
            }} path="/gap-access" />,
        ],
        'myprofile':
            [<Route render={(routeProps) => {
                mOE('contratacion');
                return <HireWelcomeAccountView {...routeProps} />;
            }} path="/myprofile/hire/welcome-account/:accountId" />,
                <Route render={(routeProps) => {
                    mOE('contratacion');
                    return <HireWelcomePayrollAccountView {...routeProps} />;
                }} path="/myprofile/hire/welcome-payroll-account" />,
                <Route render={(routeProps) => {
                    mOE('cuenta/beneficios');
                    return <AccountBenefitsViewContainer {...routeProps} />;
                }} path="/myprofile/accounts/:accountId/benefits-account-123" />,
                <Route render={(routeProps) => {
                    mOE('cuenta/domiciliacion/cambio-cuenta-recibo');
                    return <AccountDebitsChangeAccountContainer {...routeProps} />;
                }} path="/myprofile/accounts/:accountId/debits/change-receipt-account/:receiptNumber" />,
                <Route render={(routeProps) => {
                    mOE('cuentas');
                    return <SavingsAccountsOffersView {...routeProps} />;
                }} path="/myprofile/accounts/savings" />,
                <Route render={(routeProps) => {
                    mOE('depositos/imposicion/cancelacion-temprana');
                    return <ImpositionEarlyCancelContainer {...routeProps} />;
                }} path="/myprofile/deposits/:depositId/imposition/:impositionId/early-cancel" />,
                <Route render={(routeProps) => {
                    mOE('depositos/cancelar-renovacion');
                    return <DepositRenovationCancelContainer {...routeProps} />;
                }} path="/myprofile/deposits/renovation/:depositId/:contractNumber/:accountContract/cancel" />,
                <Route render={(routeProps) => {
                    mOE('depositos/imposicion/renovacion-intereses');
                    return <ImpositionInterestRenewalContainer {...routeProps} />;
                }} path="/myprofile/deposits/:depositId/imposition/:impositionId/interest-renewal/:isRenewal" />,
                <Route render={(routeProps) => {
                    mOE('depositos/imposicion/simular-cancelacion-temprana');
                    return <ImpositionEarlyCancelSimulationContainer {...routeProps} />;
                }} path="/myprofile/deposits/:depositId/imposition/:impositionId/simulate-early-cancellation" />,
                <Route render={(routeProps) => {
                    mOE('tarjeta/dinero-al-instante');
                    return <CardTransferMoneyToCheckingAccountView {...routeProps} />;
                }} path="/myprofile/cards/:cardId/transfer-money-to-checking-account" />,
                <Route render={(routeProps) => {
                    mOE('tarjeta/minicard-cambio-pin');
                    return <CancelPostPaymentView {...routeProps} />;
                }} path="/myprofile/cards/:cardId/cancel-post-payment/:movementId" />,
                <Route render={(routeProps) => {
                    mOE('tarjeta/minicard-cambio-pin');
                    return <SendPinByMailViewContainer {...routeProps} />;
                }} path="/myprofile/cards/:cardId/send-pin" />,
                <Route render={(routeProps) => {
                    mOE('tarjeta/solicitar-tarjeta-adicional');
                    return <CardRequestAdditionalViewContainer {...routeProps} />;
                }} path="/myprofile/cards/:cardId/request-additional" />,
                <Route render={(routeProps) => {
                    mOE('tarjeta/reseteo-pin');
                    return <CardPinResetViewContainer {...routeProps} />;
                }} path="/myprofile/cards/:cardId/pin-reset" />,
                <Route render={(routeProps) => {
                    mOE('tarjeta/cuenta-cargo');
                    return <CreditModifyAssociatedAccountView {...routeProps} />;
                }} path="/myprofile/cards/:cardId/modify-card-account" />,
                <Route render={(routeProps) => {
                    mOE('tarjeta/cancelar-renovacion');
                    return <CancelCreditCardRenewalView {...routeProps} />;
                }} path="/myprofile/cards/:cardId/cancel-renewal" />,
                <Route render={(routeProps) => {
                    mOE('tarjeta/cuenta-cargo/cancel-pay-later-confirm');
                    return <CancelCardPayLaterWizardView {...routeProps} />;
                }} path="/myprofile/cards/:cardId/cancel-pay-later-confirm" />,
                <Route render={(routeProps) => {
                    mOE('tarjeta/cancel-pay-later');
                    return <CancelCardPayLaterView {...routeProps} />;
                }} path="/myprofile/cards/:cardId/cancel-pay-later" />,
                <Route render={(routeProps) => {
                    mOE('tarjeta/control/historial');
                    return <CardsControlHistoryViewContainer {...routeProps} />;
                }} path="/myprofile/cards/config/:cardId/history" />,
                <Route render={(routeProps) => {
                    mOE('transferencias/bizum-alta');
                    return <AuthorizeBizumViewContainer {...routeProps} />;
                }} path="/myprofile/transfers/authorize-bizum" />,
                <Route render={(routeProps) => {
                    mOE('transferencia/bizum-baja');
                    return <CancelBizumViewContainer {...routeProps} />;
                }} path="/myprofile/transfers/cancel-bizum" />,
                <Route render={(routeProps) => {
                    mOE('depositos/alta-imposicion');
                    return <AddImpositionDepositView {...routeProps} />;
                }} path="/myprofile/deposits/:depositId/add-imposition" />,
                <Route render={(routeProps) => {
                    mOE('depositos/cambiar-cuenta');
                    return <DepositChangeAccountView {...routeProps} />;
                }} path="/myprofile/deposits/:depositId/change-account" />,
                <Route render={(routeProps) => {
                    mOE('creditos/garantias');
                    return <CreditInvestmentWarrantiesView {...routeProps} />;
                }} path="/myprofile/loans-mortgages/credit/investment-credit/:creditId/warranties" />,
                <Route render={(routeProps) => {
                    mOE('cuenta/avisos-precautorios');
                    return <AccountWarningsView {...routeProps} />;
                }} path="/myprofile/accounts/:accountId/warnings" />,
                <Route render={(routeProps) => {
                    mOE('depositos/detalles');
                    return <DepositDetailsView {...routeProps} />;
                }} path="/myprofile/deposits/:depositId/details" />,
                <Route render={(routeProps) => {
                    mOE('editar/actualizar-horario-contacto-cliente');
                    return <UpdateClientContactTimeView {...routeProps} />;
                }} path="/myprofile/edit/update-client-contact-time/:contactTimeType" />,
                <Route render={(routeProps) => {
                    mOE('tarjeta/modificar-limite-comercio-atm');
                    return <ModifyCommerceAndATMLimitsContainer {...routeProps} />;
                }} path="/myprofile/cards/:cardId/:type/modify-debit-limit" />,
                <Route render={(routeProps) => {
                    mOE('editar/actualizar-telefono-movil-principal');
                    return <ModifyMainPhoneContainer {...routeProps} />;
                }} path="/myprofile/edit/update-main-phone" />,
                <Route render={(routeProps) => {
                    mOE('cuentas');
                    return <AccountsViewWrapper {...routeProps} />;
                }} path="/myprofile/accounts/cancelled" />,
                <Route render={(routeProps) => {
                    mOE('tarjetas');
                    return <CardsViewWrapper {...routeProps} />;
                }} path="/myprofile/cards/cancelled" />,
                <Route render={(routeProps) => {
                    mOE('documentacion/envio-extractos-via-mail');
                    return <SendExtractsViaMailContainer {...routeProps} />;
                }} path="/myprofile/documentation/send-extracts-via-mail/:extractType" />],
        'broker': (
            <Route render={(routeProps) => {
                mOE('broker/cancelar-orden-pendiente-de-plan-de-pensiones');
                return <BrokerPensionPlanCancelPendingOrderContainer {...routeProps} />;
            }} path="/myprofile/broker/cancel-pension-plan-pending-order/:contractNumber/:movementId/:detailsIndex" />
        ),
    };

    if (!__CONTACT_CENTER__) {
        return null;
    }

    return CONTACT_CENTER_ROUTES[routeGroup] ? CONTACT_CENTER_ROUTES[routeGroup] : null;
};

const findRoute = (routesArray, route) => {
    return findIndex(routesArray, routeRegex => routeRegex.test(route)) !== -1;
};

const routesFilter = (onEnterCallback, history) => {
    const destination = history.location.pathname;
    const immProfile = store.getState().profile;
    if (!ENABLE_RETAIL_LOAN_HIRE_IN_CC) {
        CONTACT_CENTER_EXCLUDED_ROUTES.push(/^\/myprofile\/contract-retail-loan$/);
    }

    if ((__CONTACT_CENTER__ && findRoute(CONTACT_CENTER_EXCLUDED_ROUTES, destination)) ||
        (!__CONTACT_CENTER__ && findRoute(CONTACT_CENTER_ONLY_ROUTES, destination))) {
        history.replace('/not-found');
    } else if (__CONTACT_CENTER__ && immProfile.get('hasBeenFetched') && immProfile.get('isNerudaUser')) {
        const replaceURL = redirectToNerudaUserPages(location.pathname, true, history);
        if (replaceURL) {
            history.replace(replaceURL, { nextPathname: destination });
        }
    } else {
        return onEnterCallback(history);
    }
};

module.exports = {
    getContactCenterRoutes,
    routesFilter
};
